module.exports = __webpack_public_path__ + "03_long_yellow.103a4c33.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer5/03_long_yellow.png
// module id = J98M
// module chunks = 0